<template>
    <div id="WorkOrderEstimateMainList">
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title">{{title}}</div> 
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content estimate-lists">
                        <div class="btn-groups badge-buttons text-left mb-3">
                            <div id="divTabMenu" class="btn-group rental-btn-grup-left" role="group" aria-label="Basic example">
                                <button type="button" id="getCustomerWorkOrderEstimateList" v-on:click="getCustomerWorkOrderEstimateList(this)" :class="'btn btn-secondary '+ customerActive"> Customer <span> {{customerWoEstimateCnt}} </span> </button>
                                <button type="button" id="getVendorWorkOrderEstimateList" v-on:click="getVendorWorkOrderEstimateList(this)" :class="'btn btn-secondary '+ vendorActive"> Vendor <span> {{vendorWoEstimateCnt}} </span> </button>
                            </div>
                            <!-- <div class="mobile-action-btn">
                                <select class="selectpicker">
                                    <optgroup>
                                    <option><button type="button" id="getCustomerWorkOrderEstimateList" v-on:click="getCustomerWorkOrderEstimateList(this)" :class=customerActive> Customer <span> {{customerWoEstimateCnt}} </span> </button></option>

                                    <option><button type="button" id="getVendorWorkOrderEstimateList" v-on:click="getVendorWorkOrderEstimateList(this)" :class=vendorActive> Vendor <span> {{vendorWoEstimateCnt}} </span> </button></option>

                                    </optgroup>
                                </select>
                            </div> -->
                        </div>
                        <wo-estimate id="pendingReservationList" :estimateWorkOrderVal="cusVal" v-if="customerwoestimatedis == true"></wo-estimate>
                        <vendor-estimate id="currentReservationList" :key="venVal" :estimateVendorWoVal="venVal" v-if="vendorwoestimatedis == true"></vendor-estimate>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>  
    </div>
</template>

<script>
    import Vue from "vue";
    import EventBus from "./event-bus";
    import {commonMixins} from '../mixins/commonMixins';
    
    
    
    import CustomerEstimateList from '@/components/CustomerEstimateList';
    Vue.component("wo-estimate", CustomerEstimateList);

    import VendorEstimateList from '@/components/workorderestimate/VendorEstimateList';
    Vue.component("vendor-estimate", VendorEstimateList);
    
    var contex

    export default {
        name: "WorkOrderEstimateMainList",
        mixins:[commonMixins],
        data: () => ({

            customerWoEstimateCnt:0,
            vendorWoEstimateCnt:0,
            venVal:"vendor",
            cusVal:'customer',
            customerwoestimatedis:false,
            vendorwoestimatedis:false,
            cantAccessPage:"",
            permissions:[],
            loading: false,
            customerActive:"",
            vendorActive:"",
            title:''
        }),

        watch:{
            permissions: function(permission){
                var self = this;
                permission.forEach(function (permissions) {
                    if(permissions.name == 'list_customer_estimate' || permissions.name == 'list_vendor_estimate') {
                        self.cantAccessPage = true;
                    }
                });
                if(self.cantAccessPage == ''){
                    self.cantAccessPage = false;
                }
            }
        },

        beforeMount: function() {
            contex = this;
        },

        mounted: function () {

            var self = this;
            EventBus.$emit("profile", false);

            self.getPermissions();
             // when user came back from other page this will load the same tab selected before
             $('#divTabMenu button').removeClass("active");
            var prevSelectedTab = localStorage.getItem("estimate_list_prev_tab");
            
            setTimeout(function() {
                
                $("#divTabMenu button").removeClass("active");
                if ( self.$route.query.active == 'vendor') {
                
                    self.vendorActive = "active";
                    self.customerwoestimatedis = false;
                    self.vendorwoestimatedis = true;
                    self.title = "Vendor Estimate List";

                } else {
                    if ( prevSelectedTab == null ) {
                
                        self.customerActive = "active";
                        self.customerwoestimatedis = true;
                        self.vendorwoestimatedis = false;
                        self.title = "Customer Estimate List";
                    } else {
                        
                        if ( prevSelectedTab == 'vendor' ) {
                            
                            self.selectedStatus = "vendor";
                            self.vendorActive = 'active';
                            self.customerwoestimatedis = false;
                            self.vendorwoestimatedis = true;
                            self.title = "Vendor Estimate List";
                        } else {
                            
                            self.selectedStatus = "customer";
                            self.customerActive = 'active';
                            self.customerwoestimatedis = true;
                            self.vendorwoestimatedis = false;
                            self.title = "Customer Estimate List";
                        }
                    }
                    
                }

            setTimeout(function(){
                if (self.$route.query.from == 'vendor'){
                    self.getVendorWorkOrderEstimateList();
                }
            },500);
            

            }, 1000);

            
        },
        metaInfo() {
            var titleStr = "Estimate List | " +process.env.COPYRIGHT_NAME;
            if (this.customerwoestimatedis && !this.vendorwoestimatedis) {
                titleStr = "Customer Estimate List | " +process.env.COPYRIGHT_NAME;    
            }else if (!this.customerwoestimatedis && this.vendorwoestimatedis) {
                titleStr = "Vendor Estimate List | " +process.env.COPYRIGHT_NAME;
            }
            return{
                title: titleStr
            }
        },
        methods: {

            getVendorWorkOrderEstimateList: function(){
                var self = this;
                $('#divTabMenu button').removeClass("active");
                $("#getVendorWorkOrderEstimateList").addClass("active");
                localStorage.setItem('estimate_list_prev_tab', 'vendor');
                self.customerwoestimatedis = false;
                self.vendorwoestimatedis = true;
                self.title = "Vendor Estimate List";
            },

            getCustomerWorkOrderEstimateList: function(){
                var self = this;
                $('#divTabMenu button').removeClass("active");
                $("#getCustomerWorkOrderEstimateList").addClass("active");
                localStorage.setItem('estimate_list_prev_tab', 'customer');
                self.customerwoestimatedis = true;
                self.vendorwoestimatedis = false;
                self.title = "Customer Estimate List";
            }

        }
    };

    EventBus.$on('custWoCount', function (cnt) {
        contex.customerWoEstimateCnt = cnt;
    });
    
    EventBus.$on('vendorWoCount', function (cnt) {
        contex.vendorWoEstimateCnt = cnt;
    });

</script>





// WEBPACK FOOTER //
// src/components/EstimateMainList.vue